import { render, staticRenderFns } from "./AddPalletsGuia.vue?vue&type=template&id=0b7f6e0e"
import script from "./AddPalletsGuia.vue?vue&type=script&lang=js"
export * from "./AddPalletsGuia.vue?vue&type=script&lang=js"
import style0 from "./AddPalletsGuia.vue?vue&type=style&index=0&id=0b7f6e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports